import { formatDate, toTons } from "./utils";
import { getCurrentLanguage } from "../configuration/configuration";
import { ILanguage } from "../types";

export type FormatFn = (s: any, index?: number, length?: number) => string;

export enum FormatName {
  stringFormat = "stringFormat",
  factoryDayFormat = "factoryDayFormat",
  monthFormat = "monthFormat",
  boolFormat = "boolFormat",
  usTonFormat = "usTonFormat",
  fixed2 = "fixed2",
  fixed1 = "fixed1"
}

export const formats: Record<FormatName, FormatFn> = {
  stringFormat: (value: string): string => value,
  factoryDayFormat: (value: any): string => {
    if (typeof value !== "number") {
      return value;
    }

    // if (index && length && index > 0 && index < length - 1) {
    //   return formatDay(s);
    // }

    return formatDate(value);
  },
  monthFormat: (value: any): string => getCurrentLanguage()[`month_${value}` as keyof ILanguage] ?? value,
  boolFormat: (value: any): string => value ? "YES" : "NO",
  usTonFormat: (value: any): string => toTons(value as number) + " US ton",
  fixed2: (value: any): string => (value as number).toFixed(2),
  fixed1: (value: any): string => (value as number).toFixed(1)
};
